<template>
    <div style="height: 100%; text-align: left">
        <el-row style="height: 100%" :gutter="20">
            <el-col :span="6" style="height: 100%;padding: 10px;">
                <el-form :inline="true" size="small">
                    <el-form-item label="">
                        <el-input clearable v-model="form.engineModel" placeholder="请输入发动机型号/模板"></el-input>
                    </el-form-item>

                    <el-form-item>
                        <el-button type="primary" size="small" @click="getEngineList">{{ $t('public.query')
                        }}</el-button>
                    </el-form-item>
                </el-form>
                <el-table :data="engineList" style="width: 100%; cursor: pointer;" border height="calc(100% - 100px)"
                    max-height="calc(100% - 100px)" highlight-current-row @row-click="handleEngineRowClick">

                    <el-table-column prop="engineModelName" label="发动机型号" min-width="120"></el-table-column>
                    <!-- 操作列 -->

                </el-table>
            </el-col>
            <el-col :span="18" style="height: 100%;padding:10px;overflow: auto;">
                <div>
                    <div style="color: #ff4949;padding: 10px;text-align: center;">{{ title }}</div>
                    <el-card class="config-card" header="动力档：">
                        <el-form :inline="true" class="form-group">
                            <el-form-item label="[n1:">
                                <el-input v-model="power.n1" type="number" size="small" style="width: 70px" />
                            </el-form-item>
                            <el-form-item label="T1：">
                                <el-input v-model="power.t1" type="number" size="small" style="width: 70px" />
                            </el-form-item>

                            <el-form-item label="[n2:">
                                <el-input v-model="power.n2" type="number" size="small" style="width: 70px" />
                            </el-form-item>
                            <el-form-item label="T2：">
                                <el-input v-model="power.t2" type="number" size="small" style="width: 70px" />
                            </el-form-item>

                            <el-form-item label="[n3:">
                                <el-input v-model="power.n3" type="number" size="small" style="width: 70px" />
                            </el-form-item>
                            <el-form-item label="T3：">
                                <el-input v-model="power.t3" type="number" size="small" style="width: 70px" />
                            </el-form-item>

                            <el-form-item label="[n4:">
                                <el-input v-model="power.n4" type="number" size="small" style="width: 70px" />
                            </el-form-item>
                            <el-form-item label="T4：">
                                <el-input v-model="power.t4" type="number" size="small" style="width: 70px" />
                            </el-form-item>

                            <el-form-item label="[a:">
                                <el-input v-model="power.airQuotiety" type="number" size="small" style="width: 70px" />
                            </el-form-item>
                            <el-form-item label="Umax3：">
                                <el-input v-model="power.maxSpeed" type="number" size="small" style="width: 70px" />
                            </el-form-item>
                        </el-form>
                    </el-card>
                    <el-card style="margin-top: 10px;" class="config-card" header="平衡档：">
                        <el-form :inline="true" class="form-group">
                            <el-form-item label="[n1:">
                                <el-input v-model="balance.n1" type="number" size="small" style="width: 70px" />
                            </el-form-item>
                            <el-form-item label="T1：">
                                <el-input v-model="balance.t1" type="number" size="small" style="width: 70px" />
                            </el-form-item>

                            <el-form-item label="[n2:">
                                <el-input v-model="balance.n2" type="number" size="small" style="width: 70px" />
                            </el-form-item>
                            <el-form-item label="T2：">
                                <el-input v-model="balance.t2" type="number" size="small" style="width: 70px" />
                            </el-form-item>

                            <el-form-item label="[n3:">
                                <el-input v-model="balance.n3" type="number" size="small" style="width: 70px" />
                            </el-form-item>
                            <el-form-item label="T3：">
                                <el-input v-model="balance.t3" type="number" size="small" style="width: 70px" />
                            </el-form-item>

                            <el-form-item label="[n4:">
                                <el-input v-model="balance.n4" type="number" size="small" style="width: 70px" />
                            </el-form-item>
                            <el-form-item label="T4：">
                                <el-input v-model="balance.t4" type="number" size="small" style="width: 70px" />
                            </el-form-item>

                            <el-form-item label="[a:">
                                <el-input v-model="balance.airQuotiety" type="number" size="small" style="width: 70px" />
                            </el-form-item>
                            <el-form-item label="Umax2：">
                                <el-input v-model="balance.maxSpeed" type="number" size="small" style="width: 70px" />
                            </el-form-item>
                        </el-form>
                    </el-card>
                    <el-card style="margin-top: 10px;" class="config-card" header="经济档：">
                        <el-form :inline="true" class="form-group">
                            <el-form-item label="[n1:">
                                <el-input v-model="economy.n1" type="number" size="small" style="width: 70px" />
                            </el-form-item>
                            <el-form-item label="T1：">
                                <el-input v-model="economy.t1" type="number" size="small" style="width: 70px" />
                            </el-form-item>

                            <el-form-item label="[n2:">
                                <el-input v-model="economy.n2" type="number" size="small" style="width: 70px" />
                            </el-form-item>
                            <el-form-item label="T2：">
                                <el-input v-model="economy.t2" type="number" size="small" style="width: 70px" />
                            </el-form-item>

                            <el-form-item label="[n3:">
                                <el-input v-model="economy.n3" type="number" size="small" style="width: 70px" />
                            </el-form-item>
                            <el-form-item label="T3：">
                                <el-input v-model="economy.t3" type="number" size="small" style="width: 70px" />
                            </el-form-item>

                            <el-form-item label="[n4:">
                                <el-input v-model="economy.n4" type="number" size="small" style="width: 70px" />
                            </el-form-item>
                            <el-form-item label="T4：">
                                <el-input v-model="economy.t4" type="number" size="small" style="width: 70px" />
                            </el-form-item>

                            <el-form-item label="[a:">
                                <el-input v-model="economy.airQuotiety" type="number" size="small" style="width: 70px" />
                            </el-form-item>
                            <el-form-item label="Umax1：">
                                <el-input v-model="economy.maxSpeed" type="number" size="small" style="width: 70px" />
                            </el-form-item>
                        </el-form>
                    </el-card>
                    <div class="formula-info" style="margin-top: 10px;color: rgb(255, 140, 0);">
                        第2档: n3=Necomax2-120; n4=Necomax2+80; 第1档: n3=Necomax1-120; n4=Necomax1+80;
                    </div>
                    <el-row :gutter="20" class="necomax-row">
                        <el-col :span="24">
                            <el-form :inline="true">
                                <el-form-item label="Necomax2：">
                                    <el-input v-model="balance.ecoMax" type="number" size="small" style="width: 100px" />
                                </el-form-item>
                                <el-form-item>
                                    <el-button type="primary" size="small" @click="calcBalance">计算平衡档n3、n4</el-button>
                                </el-form-item>
                            </el-form>
                        </el-col>
                        <el-col :span="24">
                            <el-form :inline="true">
                                <el-form-item label="Necomax1：">
                                    <el-input v-model="economy.ecoMax" type="number" size="small" style="width: 100px" />
                                </el-form-item>
                                <el-form-item>
                                    <el-button type="primary" size="small" @click="calcEconomy">计算经济档n3、n4</el-button>
                                </el-form-item>
                            </el-form>
                        </el-col>
                        <el-col :span="24">
                            <div style="color: #ff4949;">{{ calctips }}</div>
                        </el-col>
                        <el-col :span="24" class="save-col">
                            <el-button type="success" @click="saveSettings" size="small">保存</el-button>
                        </el-col>
                    </el-row>
                </div>
                <div style="margin-top: 10px;">
                    <el-form :inline="true" size="small">
                        <el-form-item label="参考模板">
                            <el-select v-model="distincEngineModel" placeholder="请选择参考模板">
                                <el-option v-for="item in distinctengineList" :key="item.engineModelID"
                                    :label="item.engineModelName" :value="item.engineModelID"></el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item>
                            <el-button type="primary" size="small" @click="useTemplate">使用该模板</el-button>
                            <el-button type="primary" size="small" @click="resetTemplate">不使用模板</el-button>
                        </el-form-item>
                    </el-form>
                    <div style="color: #ff4949;" v-if="distincEngineModel">
                        <p>{{ distincEngineModelName }}的配置如下：</p>
                        <p> 动力档：{{ distincEngineModelDefine.power }}</p>
                        <p> 平衡档：{{ distincEngineModelDefine.balance }}</p>
                        <p> 经济档：{{ distincEngineModelDefine.economy }}</p>
                    </div>
                </div>
            </el-col>
        </el-row>
    </div>
</template>
<script>
import { GetEngineModelDefineList, querySmartEngineParam, GetDistinctEngineModelDefineList, querySmartEngineParamByDistinctEngineModelID, SaveSmartEngineParam } from '@/http/vehicle'
export default {
    data() {
        return {
            distincEngineModelName: undefined,
            distincEngineModel: undefined,
            distincEngineModelDefine: {
                power: undefined,//[700,125][1100,125][1500,125][2000,125],10,100
                balance: undefined,//[700,90][1100,90][1500,90][1630,25],10,100
                economy: undefined,//[700,83][1100,83][1450,83][1566,25],10,100
            },
            calctips: "",
            title: "现在显示的是所有发动机类型通用的设置",
            origin: {
                power: { n1: 600, t1: 125, n2: 1100, t2: 125, n3: 1700, t3: 125, n4: 2300, t4: 125, airQuotiety: 10, maxSpeed: 120, ecoMax: 0 },
                // 平衡档参数
                balance: { n1: 600, t1: 90, n2: 1100, t2: 90, n3: 1580, t3: 90, n4: 1780, t4: 25, airQuotiety: 10, maxSpeed: 100, ecoMax: 1700 },
                // 经济档参数
                economy: { n1: 600, t1: 83, n2: 1100, t2: 83, n3: 1480, t3: 83, n4: 1680, t4: 25, airQuotiety: 10, maxSpeed: 100, ecoMax: 1700 },
            },
            power: { n1: 600, t1: 125, n2: 1100, t2: 125, n3: 1700, t3: 125, n4: 2300, t4: 125, airQuotiety: 10, maxSpeed: 120, ecoMax: 0 },
            // 平衡档参数
            balance: { n1: 600, t1: 90, n2: 1100, t2: 90, n3: 1580, t3: 90, n4: 1780, t4: 25, airQuotiety: 10, maxSpeed: 100, ecoMax: 1700 },
            // 经济档参数
            economy: { n1: 600, t1: 83, n2: 1100, t2: 83, n3: 1480, t3: 83, n4: 1680, t4: 25, airQuotiety: 10, maxSpeed: 100, ecoMax: 1700 },
            // Necomax值
            necomax2: 1700,
            necomax1: 1700,
            form: {
                engineModel: ''
            },
            templateList: [{
                vFlieName: '模板1'
            }],
            engineList: [

            ], distinctengineList: [

            ],
            currentTemp: undefined,//当前模板
            engineModelID: undefined,//当前发动机类型ID
        }
    },
    watch: {
        distincEngineModel: {
            handler(newVal, oldVal) {
                if (newVal) {
                    this.GetSmartEngineParamByDistinctEngineModelID(newVal);
                }
            },
            immediate: true
        }
    },
    methods: {
        // 重置模板
        resetTemplate() {

            this.power = this.origin.power;
            this.balance = this.origin.balance;
            this.economy = this.origin.economy;
        },
        // 使用模板
        useTemplate() {
            if (this.currentTemp) {
                this.power = this.currentTemp[0];
                this.balance = this.currentTemp[1];
                this.economy = this.currentTemp[2];
            }
        },
        GetSmartEngineParamByDistinctEngineModelID(engineModelID) {
            this.distincEngineModelName = this.distinctengineList.find(item => item.engineModelID == engineModelID).engineModelName;

            querySmartEngineParamByDistinctEngineModelID({
                engineModelID: engineModelID
            }).then(res => {
                if (res && res.code == 200) {
                    if (res.data.length > 0) {
                        this.currentTemp = res.data;
                        this.distincEngineModelDefine.power = this.parseDefine(res.data[0]);
                        this.distincEngineModelDefine.balance = this.parseDefine(res.data[1]);
                        this.distincEngineModelDefine.economy = this.parseDefine(res.data[2]);

                        //[700,125][1100,125][1500,125][2000,125],10,100
                        //[700,90][1100,90][1500,90][1630,25],10,100
                        //[700,83][1100,83][1450,83][1566,25],10,100

                    }
                }
            }
            )

        },
        parseDefine(define) {
            return "[" + define.n1 + "," + define.t1 + "][" + define.n2 + "," + define.t2 + "][" + define.n3 + "," + define.t3 + "][" + define.n4 + "," + define.t4 + "]," + define.airQuotiety + "," + define.maxSpeed + "," + define.ecoMax;
        },
        queryDistinctEngineModelDefineList() {
            GetDistinctEngineModelDefineList({

            }).then(res => {
                if (res && res.code == 200) {
                    if (res.data.length > 0) {
                        this.distinctengineList = res.data;
                    }
                }
            }).catch(() => {
                this.$message.error(this.$t("public.error"));
            });
        },
        // 处理发动机型号行点击事件
        handleEngineRowClick(row) {
            this.engineModelID=row.engineModelID
            this.getEngineParam(row.engineModelID, row.engineModelName);
        },
        // 获取智驱的发动机参数
        getEngineParam(engineModelID, engineModelName) {
            querySmartEngineParam({
                engineModelID: engineModelID
            }).then(res => {
                if (res && res.code == 200) {
                    if (res.data.length > 0) {
                        if (engineModelID != 0) {
                            this.title = "现在显示的是 " + engineModelName + " 的设置";
                        }
                        this.power = res.data[0];
                        this.balance = res.data[1];
                        this.economy = res.data[2];
                    } else {
                        this.title = "发动机类型 " + engineModelName + " 暂无设置，现显示通用的设置";
                        this.getEngineParam(0);
                    }
                }
            }).catch(() => {
                this.$message.error(this.$t("public.error"));
            });
        },
        // 计算平衡档n3、n4
        calcBalance() {
            this.balance.n3 = parseInt(this.balance.ecoMax) - 120;
            this.balance.n4 = parseInt(this.balance.ecoMax) + 80;
            this.calctips = "Necomax2=" + this.balance.ecoMax + " 已完成计算,平衡档N3=" + this.balance.n3 + "、N4=" + this.balance.n4
        },
        // 计算经济档n3、n4
        calcEconomy() {
            this.economy.n3 = parseInt(this.economy.ecoMax) - 120;
            this.economy.n4 = parseInt(this.economy.ecoMax) + 80;
            this.calctips = "Necomax1=" + this.economy.ecoMax + " 已完成计算,经济档N3=" + this.economy.n3 + "、N4=" + this.economy.n4
        },
        // 保存设置
        saveSettings() {
            if (!this.engineModelID) {
                this.$message.error('请选择发动机型号');
                return;
            }
            if (!this.power) {
                this.$message.error('请输入动力档');
                return;
            }
            if (!this.balance) {
                this.$message.error('请输入平衡档');
                return;
            }
            if (!this.economy) {
                this.$message.error('请输入经济档');
                return;
            }
            //每个参数都不能为空
            if (!this.power.n1 || !this.power.t1 || !this.power.n2 || !this.power.t2 || !this.power.n3 || !this.power.t3 || !this.power.n4 || !this.power.t4 || !this.power.airQuotiety || !this.power.maxSpeed || !this.power.ecoMax) {
                this.$message.error('请填写完整动力档参数');
                return;
            }
            if (!this.balance.n1 || !this.balance.t1 || !this.balance.n2 || !this.balance.t2 || !this.balance.n3 || !this.balance.t3 || !this.balance.n4 || !this.balance.t4 || !this.balance.airQuotiety || !this.balance.maxSpeed || !this.balance.ecoMax) {
                this.$message.error('请填写完整平衡档参数');
                return;
            }
            if (!this.economy.n1 || !this.economy.t1 || !this.economy.n2 || !this.economy.t2 || !this.economy.n3 || !this.economy.t3 || !this.economy.n4 || !this.economy.t4 || !this.economy.airQuotiety || !this.economy.maxSpeed || !this.economy.ecoMax) {
                this.$message.error('请填写完整经济档参数');
                return;
            }

            //所有参数要改为整形
            this.power.n1 = parseInt(this.power.n1);
            this.power.t1 = parseInt(this.power.t1);
            this.power.n2 = parseInt(this.power.n2);
            this.power.t2 = parseInt(this.power.t2);
            this.power.n3 = parseInt(this.power.n3);
            this.power.t3 = parseInt(this.power.t3);
            this.power.n4 = parseInt(this.power.n4);
            this.power.t4 = parseInt(this.power.t4);
            this.power.airQuotiety = parseInt(this.power.airQuotiety);
            this.power.maxSpeed = parseInt(this.power.maxSpeed);
            this.power.ecoMax = parseInt(this.power.ecoMax);
            this.balance.n1 = parseInt(this.balance.n1);
            this.balance.t1 = parseInt(this.balance.t1);
            this.balance.n2 = parseInt(this.balance.n2);
            this.balance.t2 = parseInt(this.balance.t2);
            this.balance.n3 = parseInt(this.balance.n3);
            this.balance.t3 = parseInt(this.balance.t3);
            this.balance.n4 = parseInt(this.balance.n4);
            this.balance.t4 = parseInt(this.balance.t4);
            this.balance.airQuotiety = parseInt(this.balance.airQuotiety);
            this.balance.maxSpeed = parseInt(this.balance.maxSpeed);
            this.balance.ecoMax = parseInt(this.balance.ecoMax);
            this.economy.n1 = parseInt(this.economy.n1);
            this.economy.t1 = parseInt(this.economy.t1);
            this.economy.n2 = parseInt(this.economy.n2);
            this.economy.t2 = parseInt(this.economy.t2);
            this.economy.n3 = parseInt(this.economy.n3);
            this.economy.t3 = parseInt(this.economy.t3);
            this.economy.n4 = parseInt(this.economy.n4);
            this.economy.t4 = parseInt(this.economy.t4);
            this.economy.airQuotiety = parseInt(this.economy.airQuotiety);
            this.economy.maxSpeed = parseInt(this.economy.maxSpeed);
            this.economy.ecoMax = parseInt(this.economy.ecoMax);
            
            

            SaveSmartEngineParam({
                engineModelID: this.engineModelID,
                power: this.power,
                balance: this.balance,
                economy: this.economy
            }).then(res => {
                if (res && res.code == 200) {
                    this.$message.success('参数设置已保存');
                }
            }).catch(() => {
                this.$message.error(this.$t("public.error"));
            });

            // 这里可以添加向后端提交数据的逻辑
        },
        getEngineList() {

            GetEngineModelDefineList({
                engineModelName: this.form.engineModel
            }).then(res => {
                if (res && res.code == 200) {
                    this.engineList = res.data
                }
            }).catch(() => {
                this.$message.error(this.$t("public.error"));
            });

        }
    },
    mounted() {
        this.getEngineList();
        this.queryDistinctEngineModelDefineList();
    }
}
</script>
<style scoped>
::v-deep .el-card__body {
    padding: 8px;
}

::v-deep .el-form-item {
    margin-bottom: 8px;
}

.formula-info {
    margin: 15px 0;
    padding: 10px;
    background: #f5f7fa;
    border-radius: 4px;
    color: #606266;
    font-size: 14px;
}

.necomax-row {
    margin-top: 10px;
    align-items: center;
}

.save-col {
    text-align: center;
}
</style>